import { wrapImageOverlayer } from './Overlayer';

// const crop = {
//   type: 'custom',

//   defaultData: {},

//   methods: {},

// }

export default {
  type: 'crop',
  setup: async ({ app }) => {
    // 注册一个新的图片工具类型（往顶部工具栏添加按钮）
    app.extension.registerElementTool({
      name: 'crop',
      // label: '裁剪新',
      icon: '',
    });

    app.extension.wrapElement('image', {
      // element: wrapImageElement,
      overlayer: wrapImageOverlayer,
    });

    // 没有流接入，不需要注册这个
    // app.extension.registerProcessor('crop', crop);
  },
};
